import * as React from 'react';
import { Image, Label } from '@cian/ui-kit';

import { SuperAgentTooltip } from '../SuperAgentTooltip';
import img from '../../assets/star24.svg';

export interface ISuperAgentLabelProps {
  levelName?: string;
}

export const SuperAgentLabel: React.FC<React.PropsWithChildren<ISuperAgentLabelProps>> = () => {
  return (
    <SuperAgentTooltip isOnlyDesktop>
      <Label
        icon={<Image width={16} height={16} src={img} />}
        background={'surface-positive-default'}
        color={'current_color'}
        className={'agent-label'}
      >
        Cуперагент
      </Label>
    </SuperAgentTooltip>
  );
};

SuperAgentLabel.displayName = 'SuperAgentLabel';
